import 'materialize-css';
import $ from 'jquery';
import moment from 'moment';

$(document).ready(() => {
  // Material ui tabs
  $('.material-tabs').tabs();

  // Modals
  window.loadModals();

  // Selects
  $('.material-select').formSelect({
    dropdownOptions: {
      container: 'body',
    },
  });

  $('.material-select[required]').css({
    display: 'inline',
    position: 'absolute',
    float: 'left',
    padding: 0,
    margin: 0,
    border: '1px solid rgba(255,255,255,0)',
    height: 0,
    width: 0,
    top: '2em',
    left: '3em',
    opacity: 0,
    // pointerEvents: 'none',
  });

  // Datepickers
  $('.material-datepicker').each(function(index) {
    $(this).datepicker({
      format: 'dd-mm-yyyy',
      i18n: {
        // localization to dutch
        months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        monthsShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        weekdaysAbbrev: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
        done: 'Ok',
        cancel: 'Annuleer',
      },
      // extra settings
      autoClose: true,
      // set the date
      defaultDate: moment($(this).val(), 'DD-MM-YYYY').toDate(),
      setDefaultDate: true,
    });
  });

  $('.material-datepicker-birth-date').each(function(index) {
    $(this).datepicker({
      format: 'dd-mm-yyyy',
      yearRange: [1940, new Date().getFullYear() - 15],
      i18n: {
        // localization to dutch
        months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        monthsShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        weekdaysAbbrev: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
        done: 'Ok',
        cancel: 'Annuleer',
      },
      // extra settings
      autoClose: true,
      // set the date
      defaultDate: moment($(this).val(), 'DD-MM-YYYY').toDate(),
      setDefaultDate: true,
    });
  });

  // Timepickers
  $('.material-timepicker').timepicker({
    twelveHour: false,
    autoClose: true,
  });

  $('.material-sidenav').sidenav();

  // Dropdowns
  $('.material-dropdown-trigger').dropdown({
    coverTrigger: false,
    constrainWidth: false,
  });

  $('.material-dropdown-trigger-right').dropdown({
    alignment: 'right',
    coverTrigger: false,
    constrainWidth: false,
  });

  // Link can be a form
  $('a.submit-form').on('click', function(e) {
    e.preventDefault();

    $(`${$(this).data('form')}`).submit();
  });

  // Dismissable alerts
  $('.alert .close').on('click', function(e) {
    e.preventDefault();

    $(this)
      .closest('.alert')
      .remove();
  });

  /*
   * EXPLICIT MATERIALIZE LABEL ACTIVATION
   * -----------------------
   * This is to activate Materialize labels
   * so the label is displayed above field if value.
   * (if  active is added in blade it is removed again)
   *
   */
  M.updateTextFields();
});

window.loadModals = function() {
  $('.material-modal').modal();
};

$('.datatables-reload').on('init.dt', () => {
  window.loadModals();
});
